import React from "react";
import {
  Box,
  Button,
  Hidden,
  IconButton,
  Inline,
} from "@origin-digital/ods-core";
import PermissionsControlledWrapper from "src/components/Permissions/PermissionsControlledWrapper";
import { PermissionEnum } from "src/components/Permissions/types";
import { IconClose, IconPlus, IconSearch } from "@origin-digital/ods-icons";
import { SearchFieldResponsive } from "src/components/Form/SearchField";
import { useActionSection } from "./useActionSection";
import { useSearchAction } from "src/context/NewPremiseFormContext";

export const ActionSectionBelowMd = () => {
  const { changeSupplyButtonProps, removeSupplyButtonProps } =
    useActionSection();
  const {
    searchFieldProps,
    closeSearchIconButtonProps,
    openSearchIconButtonProps,
    searchFieldShown,
  } = useSearchAction();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={["medium", "large"]}
      data-id="actionSection.root"
    >
      {/* Actions inner container */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{
          xs: "row",
          lg: "row-reverse",
        }}
      >
        <PermissionsControlledWrapper
          requiredPermission={PermissionEnum.CREATE_REQUEST}
        >
          {/* Change/remove premises */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap="small"
            data-id="actionSection.changeRemovePremisesBox"
          >
            <Button
              size="small"
              icon={<IconPlus color="inherit" />}
              {...changeSupplyButtonProps}
            >
              <Inline>
                <Hidden below="lg">Change supply</Hidden>
                <Hidden above="lg">Change</Hidden>
              </Inline>
            </Button>
            <Button
              size="small"
              variant="outlined"
              icon={<IconPlus color="inherit" />}
              {...removeSupplyButtonProps}
            >
              <Inline>
                <Hidden below="lg">Remove supply</Hidden>
                <Hidden above="lg">Remove</Hidden>
              </Inline>
            </Button>
          </Box>
        </PermissionsControlledWrapper>
        {/* End Change/remove premises */}
        {/* Filter/search */}
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexDirection={{
            xs: "row",
            lg: "row-reverse",
          }}
          gap={{
            xs: "xxxsmall",
            md: "medium",
          }}
          data-id="actionSection.searchFieldBox"
        >
          {searchFieldShown ? (
            <IconButton {...closeSearchIconButtonProps}>
              <IconClose aria-label="Close search" size="xsmall" />
            </IconButton>
          ) : (
            <IconButton {...openSearchIconButtonProps}>
              <IconSearch aria-label="Search" size="xsmall" />
            </IconButton>
          )}
          {/* End Search (XS > MD) */}
        </Box>
        {/* End Filter/search */}
      </Box>
      {/* End Actions inner container */}
      {/* Search field (XS > MD) */}
      {searchFieldShown && <SearchFieldResponsive {...searchFieldProps} />}
      {/* End Search field (XS > MD) */}
    </Box>
  );
};
